import { ActionIcon, Burger, Tooltip } from "@mantine/core";
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from "@tabler/icons-react";
import Logo from "../Logo";
import { UserMenu } from "./UserMenu";
import classes from "./TopHeader.module.css";

export function TopHeader({
  mobileOpened,
  toggleMobile,
  desktopCollapsed,
  toggleDesktop,
  user,
}) {
  return (
    <div className={classes.topHeader}>
      <div className={classes.leftSection}>
        <Burger
          opened={mobileOpened}
          onClick={toggleMobile}
          hiddenFrom="sm"
          size="sm"
        />
        <Tooltip
          label={desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          position="right"
          withArrow
        >
          <ActionIcon
            onClick={toggleDesktop}
            className={classes.collapseButton}
            visibleFrom="sm"
            variant="subtle"
            color="gray"
            size="lg"
          >
            {desktopCollapsed ? (
              <IconLayoutSidebarLeftExpand size={24} stroke={1.5} />
            ) : (
              <IconLayoutSidebarLeftCollapse size={24} stroke={1.5} />
            )}
          </ActionIcon>
        </Tooltip>
        <Logo collapsed={false} color="#243746" height={30} />
      </div>

      <div className={classes.rightSection}>
        <UserMenu user={user} />
      </div>
    </div>
  );
}
